// removed by extract-text-webpack-plugin
module.exports = {"RadioGroup":"RadioGroup-module__RadioGroup__2F6hD","RadioGroupHidden":"RadioGroup-module__RadioGroupHidden__1wj8i"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/RadioGroupIconMulti/RadioGroup.module.css
// module id = 1735
// module chunks = 31